import React, { useState } from 'react';
import { Card } from '../shared/Card';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, ReferenceLine } from 'recharts';
export const MinutesProgressChart = () => {
  const [timeRange, setTimeRange] = useState('month');
  // Mock data for different time ranges
  const monthlyData = [{
    week: 'Week 1',
    minutes: 85,
    target: 100
  }, {
    week: 'Week 2',
    minutes: 120,
    target: 100
  }, {
    week: 'Week 3',
    minutes: 95,
    target: 100
  }, {
    week: 'Week 4',
    minutes: 140,
    target: 100
  }];
  const weeklyData = [{
    day: 'Mon',
    minutes: 15,
    target: 15
  }, {
    day: 'Tue',
    minutes: 20,
    target: 15
  }, {
    day: 'Wed',
    minutes: 25,
    target: 15
  }, {
    day: 'Thu',
    minutes: 15,
    target: 15
  }, {
    day: 'Fri',
    minutes: 0,
    target: 15
  }, {
    day: 'Sat',
    minutes: 10,
    target: 15
  }, {
    day: 'Sun',
    minutes: 0,
    target: 15
  }];
  // Get the goal value based on the selected time range
  const getGoalValue = () => {
    return timeRange === 'week' ? 100 : 400;
  };
  // Function to get appropriate data based on selected time range
  const getChartData = () => {
    if (timeRange === 'week') return weeklyData;
    return monthlyData;
  };
  // Function to get appropriate x-axis label based on selected time range
  const getXAxisKey = () => {
    if (timeRange === 'week') return 'day';
    return 'week';
  };
  // Custom tooltip for the chart
  const CustomTooltip = ({
    active,
    payload,
    label
  }) => {
    if (active && payload && payload.length) {
      return <div className="bg-white p-2 border border-gray-200 rounded-md shadow-sm" data-id="element-1367">
          <p className="font-medium" data-id="element-1368">{label}</p>
          <div className="flex items-center" data-id="element-1369">
            <div className="w-3 h-3 bg-blue-500 rounded-sm mr-2" data-id="element-1370"></div>
            <p data-id="element-1371">{payload[0].value} minutes</p>
          </div>
          <div className="flex items-center" data-id="element-1372">
            <div className="w-3 h-3 bg-gray-300 rounded-sm mr-2" data-id="element-1373"></div>
            <p data-id="element-1374">{payload[1].value} target</p>
          </div>
        </div>;
    }
    return null;
  };
  return <Card className="p-4" data-id="element-1375">
      <div className="flex justify-between items-center mb-4" data-id="element-1376">
        <h2 className="font-medium text-lg" data-id="element-1377">Minutes Progress</h2>
        <div className="flex bg-gray-100 rounded-lg overflow-hidden" data-id="element-1378">
          <button className={`px-3 py-1 text-sm ${timeRange === 'week' ? 'bg-blue-500 text-white' : 'text-gray-600'}`} onClick={() => setTimeRange('week')} data-id="element-1379">
            Week
          </button>
          <button className={`px-3 py-1 text-sm ${timeRange === 'month' ? 'bg-blue-500 text-white' : 'text-gray-600'}`} onClick={() => setTimeRange('month')} data-id="element-1380">
            Month
          </button>
        </div>
      </div>
      <div className="h-64 w-full mb-4" data-id="element-1381">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1382">
          <BarChart data={getChartData()} margin={{
          top: 10,
          right: 10,
          left: -20,
          bottom: 5
        }} data-id="element-1383">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" data-id="element-1384" />
            <XAxis dataKey={getXAxisKey()} axisLine={false} tickLine={false} data-id="element-1385" />
            <YAxis axisLine={false} tickLine={false} tickCount={5} tick={{
            fontSize: 12,
            fill: '#6b7280'
          }} data-id="element-1386" />
            <Tooltip content={<CustomTooltip data-id="element-1388" />} cursor={{
            fill: 'rgba(59, 130, 246, 0.1)'
          }} data-id="element-1387" />
            {/* Target reference line */}
            <ReferenceLine y={getGoalValue()} stroke="#f87171" strokeDasharray="5 5" strokeWidth={2} label={{
            value: `Goal: ${getGoalValue()} min`,
            fill: '#f87171',
            fontSize: 12,
            position: 'insideTopRight'
          }} data-id="element-1389" />
            <Bar dataKey="minutes" fill="#3b82f6" radius={[4, 4, 0, 0]} barSize={timeRange === 'week' ? 28 : 40} animationDuration={1000} name="Minutes" data-id="element-1390" />
            <Bar dataKey="target" fill="#e5e7eb" radius={[4, 4, 0, 0]} barSize={timeRange === 'week' ? 28 : 40} animationDuration={1000} name="Target" data-id="element-1391" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 pt-4 border-t border-gray-100" data-id="element-1392">
        <div className="flex items-center justify-between" data-id="element-1393">
          <div className="flex items-center" data-id="element-1394">
            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 text-green-600" data-id="element-1395">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1396">
                <path d="M18 15l-6-6-6 6" data-id="element-1397" />
              </svg>
            </div>
            <div data-id="element-1398">
              <p className="font-medium text-green-800" data-id="element-1399">
                {timeRange === 'week' ? '15% increase from last week' : '35% increase from last month'}
              </p>
              <p className="text-sm text-gray-600" data-id="element-1400">
                Keep up the good work! You're making great progress.
              </p>
            </div>
          </div>
          <button className="text-blue-500 text-sm font-medium hover:underline flex items-center" data-id="element-1401">
            Adjust Goal
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-1" data-id="element-1402">
              <path d="M12 20h9" data-id="element-1403"></path>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" data-id="element-1404"></path>
            </svg>
          </button>
        </div>
      </div>
    </Card>;
};